import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ScorecardsService } from '../../services/scorecards.service';
import { SCORECARDS_ACTIONS } from '../actions/scorecards.actions';
import { Store } from '@ngrx/store';

@Injectable()
export class ScorecardsEffects {
  constructor(
    private readonly store: Store,
    private readonly actions: Actions,
    private readonly scorecardsService: ScorecardsService,
  ) {}

  getScorecardsByAccountIds$ = createEffect(() =>
    this.actions.pipe(
      ofType(SCORECARDS_ACTIONS.getScorecards),
      switchMap(({ payload }) =>
        this.scorecardsService.getScorecards(payload).pipe(
          map((scorecards) => SCORECARDS_ACTIONS.getScorecardsSuccess(scorecards)),
          catchError((err: Error) => of(SCORECARDS_ACTIONS.getScorecardsError(err))),
        ),
      ),
    ),
  );
}
